import { BlockCreateInvoiceActionReason } from '../../enums/blockCreateInvoiceActionReason'
import type { Quote } from '../../types/quotes/quote'
import { getQuoteDepositInvoice } from './getQuoteDepositInvoice'
import { getQuoteDepositInvoiceDraft } from './getQuoteDepositInvoiceDraft'
import { getQuoteFinalInvoiceDraft } from './getQuoteFinalInvoiceDraft'

// Mutually exclusive - keyed off the same quote.invoiceState, which is never both NotInvoiced and PartiallyInvoiced.
export const getBlockCreateInvoiceActionReason = (quote?: Quote): BlockCreateInvoiceActionReason | undefined => {
  const existingFinalInvoiceDraft = getQuoteFinalInvoiceDraft(quote)
  const existingDepositInvoice = getQuoteDepositInvoice(quote)
  const existingDepositInvoiceDraft = getQuoteDepositInvoiceDraft(quote)

  if (existingFinalInvoiceDraft) {
    return BlockCreateInvoiceActionReason.FinalInvoiceDraftAlreadyExists
  }
  if (existingDepositInvoice?.invoiceId) {
    return BlockCreateInvoiceActionReason.DepositInvoiceUnpaid
  }
  if (existingDepositInvoiceDraft) {
    return BlockCreateInvoiceActionReason.DepositInvoiceDraftExists
  }
  return undefined
}
